module.exports = __webpack_public_path__ + "static/img/ai_pick.0846df3b.svg";